import { render, staticRenderFns } from "./IconsList.vue?vue&type=template&id=1d09de72&scoped=true&"
import script from "./IconsList.vue?vue&type=script&lang=ts&"
export * from "./IconsList.vue?vue&type=script&lang=ts&"
import style0 from "./IconsList.vue?vue&type=style&index=0&id=1d09de72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d09de72",
  null
  
)

export default component.exports